import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import classNames from 'classnames';
import { Type } from '../Type/Type';
import styles from './Accent.module.less';
export var Accent = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref2;

  var align = _ref.align,
      children = _ref.children,
      _ref$component = _ref.component,
      component = _ref$component === void 0 ? 'span' : _ref$component,
      inline = _ref.inline,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'default' : _ref$size;
  return /*#__PURE__*/React.createElement(Type, {
    align: align,
    fontFamily: "gotham",
    bold: true,
    className: classNames([(_ref2 = {}, _defineProperty(_ref2, styles['accent-small'], size === 'small'), _defineProperty(_ref2, styles.accent, size === 'default'), _ref2)]),
    component: component,
    inline: inline,
    ref: ref,
    uppercase: true
  }, children);
});
Accent.displayName = 'Accent';